/**
*** 指定したオブジェクトに合わせてバリデーションする
*** @param {*} vivaFormElements
*** @returns Object
**/

import { getParameters } from './getParameters';
import { getValidateResults } from './getValidateResults';
import { isNodeList, getName, getType, getErrorElement, errorMessage } from './functions';
import { vfClassName, typeArray } from './elements';



// エラーメッセージの表示処理
const execError = ( target, element, message ) => {

  if( ! element ) return;

  element.innerHTML = errorMessage(message);
  element.classList.add(vfClassName.valid);

  // input 要素のものはエラー用の .error クラスを付ける
  if( typeArray[0].includes( getType(target) ) || getType(target) === 'select-one' ){
    target.classList.add(vfClassName.error);
  };

}



// エラーメッセージの消去処理
const eraseError = ( target, element ) => {

  if( ! element ) return;

  element.innerHTML = '';
  element.classList.remove(vfClassName.valid);

  // input 要素のものはエラー用の .error クラスを付ける
  if( typeArray[0].includes( getType(target) ) || getType(target) === 'select-one' ){
    target.classList.remove(vfClassName.error);
  };

}



export const processValidation = ( target ) => {

  // パラメータを取得する
  const params = getParameters(target);

  // グローバルパラメータに収納する
  Parameters.params[params.name] = params;

  // rules に含まれているものだけバリデーションする
  if( params.name in Parameters.rules === false ) return true;



  // バリデーションの結果を取得（オブジェクトが返ってくる）
  const result = getValidateResults( params, Parameters.rules[params.name] );

  // エラーメッセージを表示する要素を取得する（ [] を取り除く）
  const elementID = getName( Parameters.group, params.name );
  const errorElement = getErrorElement( params.name, Parameters.group );

  // エラーメッセージを表示する要素のスクロールトップを収納する
  //Parameters.scroll.push(params.scroll);



  // グループあり
  if( params.group ) {

    // グループに属している name を取得
    const groups = Parameters.group[elementID].split(' ');

    // グループ内のバリデーションの結果の容れ物
    let groupCase = {};

    // グループ内のバリデーションの結果を取得する
    for( const name of groups ) {
      //if( params.name === name ) continue; // 自身は除く

      const groupTarget = vivaFormElements[name];
      const groupParams = getParameters(groupTarget);
      Parameters.params[name] = groupParams; // グローバルパラメータに収納する
      const groupResult = getValidateResults(groupParams, Parameters.rules[name]);

      groupCase[name] = {
        message: groupResult.message,
        valid  : groupResult.valid
      };

    };



    for( const name in groupCase ){

      // error
      if( groupCase[name].valid === false ){
        execError(vivaFormElements[name], errorElement, groupCase[name].message);
        // エラーメッセージを表示する要素のスクロールトップを収納する
        Parameters.scroll[name] = params.scroll;
        return false;
      }
      else {
        eraseError(vivaFormElements[name], errorElement);
      };
    };

    return true;
  };



  // グループではない
  //
  // エラーなし（ result.valid = true ）
  if( result.valid === true ){
    eraseError(target, errorElement);
    return true;
  }
  // エラーあり（ result.valid = false ）
  else {
    execError(target, errorElement, result.message);
    // エラーメッセージを表示する要素のスクロールトップを収納する
    Parameters.scroll[params.name] = params.scroll;
    return false;
  };

};
